/* Farbe und Zeichen aus dem Theme: Hinweis in der Hauptfarbe, Fehler im Signalton. Nicht die eingefrorenen
   Antd-Tokens (`colorInfo` + festes Weiß) — in Noir dunkel ist die Hauptfarbe hell, Weiß darauf unlesbar. */
.mq-attention-indicator {
  --mq-attention-color: var(--mq-theme-primary);
  --mq-attention-ink: var(--mq-theme-on-primary);
  display: inline-grid;
  place-items: center;
  flex: none;
  border-radius: var(--mq-pill-radius);
  vertical-align: middle;
  background: var(--mq-attention-color);
  color: var(--mq-attention-ink);
}
.mq-attention-indicator--error {
  --mq-attention-color: var(--mq-theme-signal);
  --mq-attention-ink: var(--mq-kit-signal-text);
}
.mq-attention-indicator--dot { width: 8px; height: 8px; }
.mq-attention-indicator--count {
  min-width: 20px;
  height: 20px;
  padding: 0 var(--mq-count-padding-inline);
  font-size: var(--mq-font-size-xs);
  font-weight: 700;
  line-height: var(--mq-line-height-solid);
  font-variant-numeric: tabular-nums;
}
.mq-attention-indicator--pulse { animation: mq-attention-indicator-pulse 1.2s ease-in-out infinite; }
@keyframes mq-attention-indicator-pulse { 50% { opacity: 0.3; } }
@media (prefers-reduced-motion: reduce) { .mq-attention-indicator--pulse { animation: none; } }
